import { resolveTypeBasedErrorContent } from "@/util/errorContentResolver";
import { useI18n } from "vue-i18n";

export function useErrorResolver() {
  const { t, te } = useI18n();

  const resolveErrorMessage = (
    error: any,
    namespace: string,
    fallbackKey = "common.somethingWentWrong"
  ): string => {
    return resolveTypeBasedErrorContent({
      error,
      namespace,
      fallbackKey,
      t,
      te,
    });
  };

  return { resolveErrorMessage };
}
